<template>
  <div class="left-menu">
    <el-scrollbar style="height: 100vh">
      <div class="flex align-items flex-center padding-bottom_12 padding-top_8">
        <img src="../../../assets/homePage/LOGO_quan@2x.png" width="112" height="40" alt="logo" @click="toIndex" />
      </div>
      <left-menu-item :list="menuTreeList" @activeMenu="handleActiveMenu">
      </left-menu-item>
    </el-scrollbar>
  </div>
</template>

<script>
import { post, fetch } from "@/ask/axios";
import LeftMenuItem from "./leftMenuItem.vue";
import bus from "@/ask/eventBus";
export default {
  components: { LeftMenuItem },
  data() {
    return {
      menuList: [], // 扁平化数组
      menuTreeList: [], // 树形数组
    };
  },
  computed: {},
  watch: {
    $route: {
      handler(val) {
        this.getMenuList();
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.getMenuList();
  },
  mounted() {
    // 重新从接口获取菜单数据
    bus.$on("regainMenuList", (val) => {
      this.getMenuList(1);
    });
  },
  methods: {
    toIndex() {
      window.location.href = '/';
    },
    // 菜单初始化
    async menuInit(type = 0) {
      this.menuList.forEach((item) => {
        // this.$set(
        //   item,
        //   "MenuUrl",
        //   item.MenuUrl && "/#" + item.MenuUrl.split("#")[1]
        // );
        this.$set(item, "IsOpen", false);
        this.$set(item, "IsActive", false);
        this.$set(item, "IsActiveParent", false);
        // 添加不显示在左侧菜单的子菜单高亮
        this.$set(item, "IncludeUrlList", this.addIncludeUrl(item));
      });

      this.menuList.forEach((item) => {
        if (this.$route.path && item.MenuUrl) {
          // console.log(this.$route.path, 'this.$route.path');
          // console.log(item.IncludeUrlList, 'item.IncludeUrlList');
          // if (this.$route.path == item.MenuUrl.split("#")[1]) {
          if (
            item.IncludeUrlList.includes(this.$route.path) ||
            this.$route.path == item.MenuUrl.split("#")[1]
          ) {
            this.$set(item, "IsOpen", true);
            this.$set(item, "IsActive", true);
            this.$set(item, "IsActiveParent", true);
            // 如果是一级菜单以下的，上一级菜单需要打开
            if (item.ParentID != 0 && item.IsOpen) {
              let array = this.findActiveMenu(item, 1);
            }
            console.log("currentMenu", item);
          } else {
            this.$set(item, "IsActive", false);
          }
        } else {
          this.$set(item, "IsActive", false);
        }
      });
      // 菜单转为树形数组
      this.menuTreeList = await this.arrayToTree(this.menuList);

      console.log(this.menuList, "created");
      // 缓存树形菜单
      if (type == 0) {
        // sessionStorage.setItem("MenuInfo", JSON.stringify(this.menuTreeList));
        sessionStorage.setItem("MenuInfo", JSON.stringify(this.menuList));
      }
    },
    async getMenuList(type = 0) {
      // 判断是否未认证
      // 判断是否有缓存，有就用缓存菜单
      if (type == 0) {
        let menuInfo = sessionStorage.getItem("MenuInfo");
        if (!["null", undefined, null].includes(menuInfo)) {
          this.menuList = JSON.parse(menuInfo);
          // this.menuList = this.treeToArray(this.menuTreeList);
          if (this.menuList.length > 0) {
            // 菜单初始化
            this.menuInit(1);
            return false;
          }
        }
      }

      let url = this.$api04 + "/BasicsSupplier/api/Menu/Query";

      await post(url, {}).then(async (res) => {
        if (res.IsOK) {
          this.menuList = res.Results;
          // 菜单初始化
          this.menuInit();
        }
      });
    },
    // 扁平化转树形数组
    arrayToTree(list) {
      return new Promise((resolve, reject) => {
        if (true) {
          let result = [],
            map = [];

          list.forEach((item) => {
            map[item.ID] = { ...item, Children: [] };
          });

          list.forEach((item) => {
            let newItem = map[item.ID];
            if (item.ParentID == 0) {
              result.push(newItem);
            } else {
              if (Object.prototype.hasOwnProperty.call(map, item.ParentID)) {
                map[item.ParentID].Children.push(newItem);
              }
            }
          });

          for (let i = 0; i < result.length - 1; i++) {
            for (let j = 0; j < result.length - 1 - i; j++) {
              if (result[j]["Sort"] > result[j + 1]["Sort"]) {
                let temp = result[j];
                result[j] = result[j + 1];
                result[j + 1] = temp;
              }
            }
          }
          return resolve(result);
        } else {
          reject();
        }
      });
    },
    // 数组转扁平化
    treeToArray(tree) {
      let result = [];
      tree.forEach((item) => {
        let { Children, ...i } = item;
        if (Children.length > 0) {
          result = result.concat(this.treeToArray(Children));
        }
        result.push(i);
      });
      return result;
    },
    // 打开下一级菜单或者点击菜单跳转
    async handleActiveMenu(activeMenuItem) {
      let activeMenu = activeMenuItem;

      this.menuList.forEach((item) => {
        // 从扁平化菜单中找出当前打开的菜单或者高亮菜单
        if (item.MenuName == activeMenu.MenuName) {
          console.log("currentBefore", item);
          // 菜单打开或者关闭下一级
          this.$set(item, "IsOpen", !item.IsOpen);
          // 判断是否有url, 没有就是菜单跳转
          if (item.MenuUrl) {
            this.$set(item, "IsActive", true);
            this.$set(item, "IsActiveParent", true);
          }
          // // 如果是一级菜单以下的，上一级菜单需要打开
          // if (item.ParentID != 0 && item.IsOpen) {
          //   this.findActiveMenu(activeMenu);
          // }
        } else {
          // 如果只是打开菜单，高亮的菜单不变
          if (activeMenu.MenuUrl) {
            this.$set(item, "IsActive", false);
          }
          // this.$set(item, "IsOpen", false);
        }
      });

      this.menuList.forEach((item) => {
        // 从扁平化菜单中找出当前打开的菜单或者高亮菜单
        if (item.MenuName == activeMenu.MenuName) {
          // 如果是一级菜单以下的，上一级菜单需要打开
          if (item.ParentID != 0 && item.IsOpen) {
            let array = this.findActiveMenu(item);
          }

          // if (item.ParentID != 0 && activeMenu.IsActive) {
          //   let array = this.findActiveMenu(item);
          // }
        }
      });

      // 扁平化菜单转为树形菜单
      let w = window.location;
      await this.arrayToTree(this.menuList).then((res) => {
        this.menuTreeList = res;
        sessionStorage.setItem("MenuInfo", JSON.stringify(this.menuList));
        // 如果是有链接可跳转的菜单，就跳转
        if (activeMenuItem.MenuUrl) {
          w.href = activeMenu.MenuUrl;
        }
      });

      // 缓存菜单
      // sessionStorage.setItem("MenuInfo", JSON.stringify(this.menuTreeList));
    },
    // 递归打开上一级菜单
    // async findActiveMenu(activeMenu) {
    //   let that = this;
    //   return await new Promise((resolve, reject) => {
    //     if (true) {
    //       that.menuList.forEach((item) => {
    //         if (item.ID == activeMenu.ParentID) {
    //           that.$set(item, "IsOpen", true);
    //           if (item.ParentID != 0 && item.IsOpen) {
    //             that.findActiveMenu(item);
    //           } else if (item.ParentID == 0) {
    //             that.$set(item, "IsOpen", true);
    //           }
    //         }
    //       });
    //       return resolve();
    //     } else {
    //       return reject();
    //     }
    //   });
    // },
    findActiveMenu(activeMenu, type = 0) {
      let that = this;
      for (let i = 0; i < that.menuList.length; i++) {
        let item = that.menuList[i];
        if (item.ID == activeMenu.ParentID) {
          that.$set(item, "IsOpen", true);
          if (type == 1) {
            this.$set(item, "IsActiveParent", true);
          }

          if (item.ParentID != 0 && item.IsOpen) {
            let array = that.findActiveMenu(item);
          } else if (item.ParentID == 0) {
            that.$set(item, "IsOpen", true);
            if (type == 1) {
              this.$set(item, "IsActiveParent", true);
            }
            return [];
          }
        }
      }
      return [];
    },
    // 添加高亮
    addIncludeUrl(item) {
      let addUrlList = {
        // 首页
        "/homePage": [
          "/homePage",
          "/personalCenter/certification", // 实名认证
        ],
        /** 订单管理 */
        // 快递订单
        "/orderManagement/exp": [
          "/orderManagement/exp",
          "/orderManagement/exp-Detail",
        ],
        // FBA订单
        "/orderManagement/fba": [
          "/orderManagement/fba",
          "/orderManagement/fba-Detail",
        ],
        // 空运订单
        "/orderManagement/air": [
          "/orderManagement/air",
          "/orderManagement/airDetail",
        ],
        // 询盘订单
        "/orderManagement/inquiry": [
          "/orderManagement/inquiry",
          "/orderManagement/inquiryDetail",
          "/orderManagement/offerNow",
        ],
        // 取件订单
        "/orderManagement/pickup": [
          "/orderManagement/pickup",
          "/orderManagement/pickupDetail",
        ],

        /** 渠道管理 */
        // 快递渠道
        "/channelManagement/exp": [
          "/channelManagement/exp",
          "/channelManagement/addEdit",
          "/channelManagement/expEdit",
        ],
        // exp查价
        "/channelManagement/expCheckPrice": [
          "/channelManagement/expCheckPrice",
        ],
        // FBA渠道
        "/channelManagement/fba": [
          "/channelManagement/fba",
          "/channelManagement/addEditFBA",
          "/channelManagement/fbaEdit",
        ],
        // fba查价
        "/channelManagement/fbaCheckPrice": [
          "/channelManagement/fbaCheckPrice",
        ],
        // 空运渠道
        "/channelManagement/airChannelList": [
          "/channelManagement/airChannelList",
          "/channelManagement/addAirChannel",
          "/channelManagement/editAirChannel",
        ],
        // 取件渠道
        "/channelManagement/pickupChannelList": [
          "/channelManagement/pickupChannelList",
          "/channelManagement/addPickupChannel",
          "/channelManagement/editPickupChannel",
        ],

        /** 操作管理 */
        // 空运操作列表
        "/operationManagement/air": [
          "/operationManagement/air",
          // "/orderManagement/airDetail",
          // "/channelManagement/editPickupChannel",
        ],
      };
      if (item.MenuUrl) {
        //  console.log(item.MenuUrl, 1);
        let url = item.MenuUrl.split("#")[1];
        // console.log(url, 2);

        // console.log(addUrlList[url], 3);

        // this.$set(item, "IncludeUrlList", addUrlList[url] || []);
        return addUrlList[url] || [];
      } else {
        // this.$set(item, "IncludeUrlList", []);
        return [];
      }
    },
  },
};
</script>

<style scoped lang="scss">
.left-menu {
  div {
    height: auto;
    font-size: 13px;
    color: #fff;
  }

  .menu-item1 {
    padding: 8 0px;
    line-height: 48px;
    font-size: 14px;
  }
}
</style>
